import { CA, P, createSlice } from '@redux/slices';

import { fetchSelfData } from '../selfData';

export const selfData = createSlice(CA(P('SELF_DATA')), fetchSelfData, {
  initialState: { projects: [] },
});
